import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { ReportCodeFilter } from "./ViewModels/ReportCodeFiltersViewModel";
import ReportCodeFiltersDialog from "./ReportCodeFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IRepCodeFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function ReportCodeFilters({ callTableViewModel, setCallTableViewModel }: IRepCodeFiltersProps) {
    const [open, setOpen] = useState(false);

    const displayRepCodes = (reportCodeName: string, reportCode: ReportCodeFilter) => {
        var result = '';

        if (reportCode.values.length > 0) {
            if (reportCodeName === 'Reportcode 2'
                && callTableViewModel.filters.reportCodeFilters.reportCode1.values.length > 0) {
                result += ' - ';
            }
            if (reportCodeName === 'Reportcode 3'
                && (callTableViewModel.filters.reportCodeFilters.reportCode1.values.length > 0 || callTableViewModel.filters.reportCodeFilters.reportCode2.values.length > 0)) {
                result += ' - ';
            }
            if (reportCodeName === 'Reportcode 5'
                && (callTableViewModel.filters.reportCodeFilters.reportCode1.values.length > 0 || callTableViewModel.filters.reportCodeFilters.reportCode2.values.length > 0 || callTableViewModel.filters.reportCodeFilters.reportCode3.values.length > 0)) {
                result += ' - ';
            }
        }

        if (reportCode.values.length > 0) {
            result += `${reportCodeName}: `;
            result += reportCode.excluded ? 'Exclude ' : 'Include '
            if (reportCode.values.length > 1) {
                result += 'Many';
            }
            else {
                result += reportCode.values[0];
            }
        }

        return result;
    }

    const text =
        <Typography variant="body1">
            {
                callTableViewModel.filters.reportCodeFilters.reportCode1.values.length === 0
                && callTableViewModel.filters.reportCodeFilters.reportCode2.values.length === 0
                && callTableViewModel.filters.reportCodeFilters.reportCode3.values.length === 0
                && callTableViewModel.filters.reportCodeFilters.reportCode5.values.length === 0
                &&
                'Reportcodes'
            }
            {
                displayRepCodes('Reportcode 1', callTableViewModel.filters.reportCodeFilters.reportCode1)
            }
            {
                displayRepCodes('Reportcode 2', callTableViewModel.filters.reportCodeFilters.reportCode2)
            }
            {
                displayRepCodes('Reportcode 3', callTableViewModel.filters.reportCodeFilters.reportCode3)
            }
            {
                displayRepCodes('Reportcode 5', callTableViewModel.filters.reportCodeFilters.reportCode5)
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <ReportCodeFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}